import { Alert } from "@omni/ui/components/Alert/alert.component";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    message: string;
    handleDelete?: () => void;
};

const ErrorMessage = ({ message, handleDelete }: Props) => {
    const { t } = useGranite();
    return (
        <Alert
            id="errorMessage"
            color="danger"
            isOpen={true}
            closeAriaLabel={t("general.alert.close")}
            toggle={handleDelete ? () => handleDelete() : undefined}
        >
            {message}
        </Alert>
    );
};

export default ErrorMessage;
